<template>
  <div>
    <vx-card class="mt-3">
          <vs-table
      :sst="true"
      v-model="selected"
      pagination
      max-items="10"
      search
      :data="navigationStatuss"
    >
      <template slot="header">
        <vs-button
          style="margin-left:5px;margin-top:5px"
          icon-pack="feather"
          icon="icon-plus"
          
          @click="popupAdd=true"
        >Add Navigation status</vs-button>
      </template>
      <template slot="thead">
        <vs-th sort-key="code">Code</vs-th>
        <vs-th sort-key="name">Name</vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr v-for="(tr, indextr) in data" :data="tr" :key="indextr">
          <vs-td :data="data[indextr].code">{{ data[indextr].code }}</vs-td>
          <vs-td :data="data[indextr].name">{{ data[indextr].name }}</vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <vs-button color="danger" class="m-3">Delete</vs-button>
    <vs-button color="warning" class="m-3" >Edit</vs-button>

    </vx-card>
    <div class="demo-alignment">
      <vs-popup :active.sync="popupAdd" classContent="popup-example" title="New navigation status">
        <vs-input v-model="navigationStatus.code" class="w-full mb-3" placeholder="code" />
        <vs-input v-model="navigationStatus.name" class="w-full mb-3" placeholder="name" />
        <vs-button @click="insertMid()" color="primary" class="w-full" type="filled">Save</vs-button>
      </vs-popup>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { API_BASE_URL } from '@/constants'

export default {
  data() {
    return {
      selected: [],
      navigationStatuss: [],
      navigationStatus:{
        code:'',
        name:''
      },
      accessEmail: "",
      accessToken: "",
       selected: [],
      popupAdd: false,
      popupEdit: false
    };
  },
  mounted() {
    this.$vs.loading();
    this.accessEmail = localStorage.getItem("accessEmail");
    this.accessToken = localStorage.getItem("accessToken");
    this.$store.dispatch("updateTitlePage", "Navigation status");
    this.getNavigationStatuss();
  },
  methods: {
    
    getNavigationStatuss() {
      
      axios
        .get(`${API_BASE_URL}/admin/navigation_statuses.json`, {
          params: {
            limit: 100
          },
          headers: {
            "X-User-Email": this.accessEmail,
            "X-User-Token": this.accessToken
          }
        })
        .then(response => {
          this.navigationStatuss = response.data;
          this.$vs.loading.close();
        })
        .catch(error => {
          console.log("Error call apis :", error);
        });
    }
  }
};
</script>